import React from 'react';

export default () => (
  <section style={{width: '100%'}}>
    <div className="spi" style={{height:'40px', width: '40px'}}></div>
  </section>
);
